var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspectionPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D8C041"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2128 20.8936C17.2766 20.8936 18.1809 20.5213 18.9256 19.7766C19.6702 19.0319 20.0426 18.1277 20.0426 17.0639C20.0426 16 19.6702 15.0958 18.9256 14.3511C18.1809 13.6064 17.2766 13.2341 16.2128 13.2341C15.149 13.2341 14.2447 13.6064 13.5 14.3511C12.7553 15.0958 12.383 16 12.383 17.0639C12.383 18.1277 12.7553 19.0319 13.5 19.7766C14.2447 20.5213 15.149 20.8936 16.2128 20.8936ZM16.2128 19.1915C15.617 19.1915 15.1135 18.9858 14.7021 18.5745C14.2908 18.1631 14.0851 17.6596 14.0851 17.0639C14.0851 16.4681 14.2908 15.9646 14.7021 15.5532C15.1135 15.1419 15.617 14.9362 16.2128 14.9362C16.8085 14.9362 17.3121 15.1419 17.7234 15.5532C18.1348 15.9646 18.3404 16.4681 18.3404 17.0639C18.3404 17.6596 18.1348 18.1631 17.7234 18.5745C17.3121 18.9858 16.8085 19.1915 16.2128 19.1915ZM9.40428 23.8724C8.93619 23.8724 8.53548 23.7057 8.20215 23.3724C7.86882 23.039 7.70215 22.6383 7.70215 22.1702V11.9575C7.70215 11.4894 7.86882 11.0887 8.20215 10.7553C8.53548 10.422 8.93619 10.2553 9.40428 10.2553H12.0851L13.6596 8.55322H18.766L20.3404 10.2553H23.0213C23.4894 10.2553 23.8901 10.422 24.2234 10.7553C24.5568 11.0887 24.7234 11.4894 24.7234 11.9575V22.1702C24.7234 22.6383 24.5568 23.039 24.2234 23.3724C23.8901 23.7057 23.4894 23.8724 23.0213 23.8724H9.40428ZM9.40428 22.1702H23.0213V11.9575H19.5745L18.0213 10.2553H14.4043L12.8511 11.9575H9.40428V22.1702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionPhotoIcon);
export default __webpack_public_path__ + "static/media/inspection_photo_icon.cffa99e39be2db2c015d95fee12976dc.svg";
export { ForwardRef as ReactComponent };